import React from "react";

export const KeyboardExplanation: React.FC = () => (
    <div>
        <p>キーボード操作</p>
        <p>移動 : [←][↓][→] or [a][s][d]</p>
        <p>回転 : [z][x] or [k][l]</p>
        <p>ハードドロップ : [↑] or [w]</p>
        <p>ホールド : [Shift]</p>
        <p>一手戻る : [Space]</p>
    </div>
)
